import './polyfill';
import initialize from '@src/initialize';
import constants from '@src/constants';
import renderApp from '@src/render-app';
import { loadFontsWhenIdle } from './utils/load-font';

require('./tracker/track-page-load');
require('./tracker/track-page-leave');
/**
 * 禁止浏览器自动帮助恢复滚动位置
 * @type {string}
 */
window.history.scrollRestoration = 'manual';

(async () => {
  if (DEPLOY_ENV !== 'master' && constants.IS_MOCK_ON) {
    await require('@xfe-team/utils/src/intercept-jsonp-with-mocks').default(require('@src/services/zt/mock.json'));
  }

  /**
   * 初始化
   */
  initialize();

  renderApp();

  /**
   * 异步加载字体，不阻塞首屏渲染
   */
  setTimeout(() => {
    loadFontsWhenIdle();
  }, 500);
})();

/**
 * 热更新
 */
if (module.hot) {
  module.hot.accept();
}
